<template>
  <div class="job-detail">
    <h1 class="job-detail-title">{{ jobDetail.postName }}</h1>
    <div class="job-detail-subTitle" v-if="jobDetail.id">
      <span class="city_info">{{ jobDetail.age }}</span
      >&nbsp;|
      <span class="job_category">{{ jobDetail.profession }}</span
      >&nbsp;|
      <span class="recruit_type">{{ jobDetail.educationBackground }}</span>
    </div>
    <div class="job-detail-description job-detail-block">
      <h2>职位描述</h2>
      <pre class="textContent">{{ jobDetail.positionRequirement }}</pre>
    </div>
    <div class="job-detail-requirement job-detail-block">
      <h2>笔试开考比例</h2>
      <pre class="textContent">{{ jobDetail.writtenExamProportion }}</pre>
      <h2>入闱现场审核的人员比例</h2>
      <pre class="textContent">{{ jobDetail.sceneVerifyProportion }}</pre>
      <h2>备注</h2>
      <pre class="textContent">{{ jobDetail.remark }}</pre>
    </div>
    <div class="job-detail-button job-detail-block" v-if="jobDetail.status === 0">
      <bytedance-button @click="deliveryDialog" size="large">投递</bytedance-button>
    </div>

    <!--    是否服从调剂对话框-->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" label-width="160px">
        <el-form-item label="是否服从岗位调剂" prop="regulate">
<!--          <el-input v-model="form.regulate" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" disabled/>-->
          <el-select
              v-model="form.regulate"
              placeholder="是否服从岗位调剂"
              clearable
              size="small"
          >
            <el-option
                v-for="dict in regulateOptions"
                :key="dict.value"
                :label="dict.label"
                :value="parseInt(dict.value)"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="submitDelivery">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {state} from "@/store";
export default {
  name: "job-detail",
  data() {
    return {
      jobDetail: {},
      open: false,
      title: "",
      form: {},
      regulateOptions: [{
        value: 0,
        label: '否'
      }, {
        value: '1',
        label: '是'
      }],
    };
  },

  methods: {
    submitDelivery() {
      if (this.form.regulate === undefined || this.form.regulate === null) {
        this.$message.warning("请选择是否服从岗位调剂");
        return;
      }
      if (!state.isLogin) {
        this.$router.push("/login");
      } else {
        let loading = this.$loading({ position: { top: 60 } });
        this.request
            .post(`/zpPersonalBusiness/delivery`, {
              idCard: state.userInfo.userName,
              requireUuid: this.jobDetail.uuid,
              batchNumber: this.jobDetail.batchNumber,
              regulate: this.form.regulate,
            })
            .then(res => {
              if(200 === res.code){
                this.$message.success("投递成功");
              } else {
                this.$message.error( res.msg);
              }
              loading.close();
              this.cancel();
            })
            .catch(loading.close);
      }
    },
    deliveryDialog() {
      this.open = true;
      this.title = "投递确认";
    },
    cancel() {
      this.open = false;
      this.form.regulate = null;
    },
  },
  created() {
    let loading = this.$loading({ position: { top: 60 } });
    // store.requestUserInfo();
    const { id } = this.$route.params;
    this.request
      .get(`/zpPersonalBusiness/${id}`)
      .then(res => {
        this.jobDetail = res.data;
        loading.close();
      })
      .catch(loading.close);
  }
};
</script>
<style lang="less" scoped>
.job-detail {
  width: 800px;
  
  margin: auto;
  margin-top: 100px;
  line-height: 2em;
  &-subTitle {
    font-size: @font-size-base;
    color: @primary-text-color;
    margin: 20px 0;
  }
  &-description {
    .textContent {
      white-space: pre-line;
    }
  }
  &-block {
    h2 {
      margin-bottom: 20px;
    }
    margin: 40px 0;
    .textContent {
      font-size: @font-size-base;
      color: @primary-text-color;
    }
  }
  &-button {
    width: 200px;
  }
}
</style>
